import { memo } from 'react';
import type { TableCellProps } from './TableCell';
import TableCell from './TableCell';

const ConditionalWidthTableCell = ({
    width,
    fixedWidth,
    children,
    ...props
}: TableCellProps & { fixedWidth?: boolean }) => (
    <TableCell {...props} width={fixedWidth ? width : undefined}>
        {children}
    </TableCell>
);

export default memo(ConditionalWidthTableCell);
